import {isDev, isHelp, scrollSetting} from "./globalVars";

export default class Helper {
    constructor () {
        // 테스트 아이피가 아닐 경우 실행하지 않음
        if (!isDev()) return;

        this.dom = document.getElementById("app");
        this.addEvent();

        this.toggleGrid(parseInt(this.getCookie('isHelp')));
    }

    addEvent () {
        window.addEventListener('keyup',(e)=>{
            if (e.keyCode === 71) {
                this.isHelp ? this.toggleGrid(false) : this.toggleGrid(true);
            }
        });

    }

    toggleGrid ($isHelp) {
        if (!$isHelp) {
            this.isHelp = false;
            this.setCookie('isHelp', 0, 10);
            document.querySelector('.grid-helper').classList.add('none');
            document.querySelector('section').classList.remove('guide-helper');
        } else {
            this.isHelp = true;
            scrollSetting.markers = true;
            this.setCookie('isHelp', 1, 10);
            document.querySelector('.grid-helper').classList.remove('none');
            document.querySelector('section').classList.add('guide-helper');
        }
    }

    getCookie ($name) {
        let nameEQ = $name + "=";
        let ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    setCookie ($name, $value, $days) {
        let expires = "";

        if ($days) {
            let date = new Date();
            date.setTime(date.getTime() + ($days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = $name + "=" + $value + expires + "; path=/";
    }

}

